import { useEffect, useState } from 'react';

/** After this long, say it is still working. */
export const SLOW_MS = 5_000;

/**
 * SAY THAT THE TABLE IS UPDATING. A lens change in a busy room once took two
 * minutes with the old table on screen and nothing to say anything was
 * happening. Quiet at first; after five seconds it says it is still working.
 * It names no cause: why a busy room's tables slow down is not settled yet,
 * and a reason on screen is a claim.
 */
export default function UpdatingNote({ loading, digging }: { loading: boolean; digging?: boolean }) {
  const [slow, setSlow] = useState(false);
  useEffect(() => {
    setSlow(false);
    if (!loading) return;
    const t = window.setTimeout(() => setSlow(true), SLOW_MS);
    return () => window.clearTimeout(t);
  }, [loading]);
  if (!loading) return null;
  return (
    <span
      role="status"
      className={`inline-flex items-center gap-1.5 text-xs ${
        slow ? 'text-amber-700 dark:text-amber-300' : 'text-gray-500 dark:text-gray-400'
      }`}
      data-testid="table-updating"
    >
      <span aria-hidden className="inline-block h-2 w-2 animate-pulse rounded-full bg-current" />
      {slow
        ? `Still updating${digging ? ' - this can take a while during a dig' : ''}…`
        : 'Updating…'}
    </span>
  );
}
